const API_URL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || "http://localhost:8080";

export const authService = {
  async login(email, password) {
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-MCP-Protocol": "1.0",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error("Credenciais inválidas");
    }

    const data = await response.json();
    // Salvar token no localStorage
    localStorage.setItem("authToken", data.token);
    localStorage.setItem("userEmail", data.email);
    localStorage.setItem("userName", data.name);
    localStorage.setItem("userPlan", data.plan);
    return data;
  },

  async register(email, password, name, phone, companyName, plan) {
    const response = await fetch(`${API_URL}/api/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-MCP-Protocol": "1.0",
      },
      body: JSON.stringify({ email, password, name, phone, companyName, plan }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || "Erro ao criar conta");
    }

    const data = await response.json();
    // Salvar token no localStorage
    localStorage.setItem("authToken", data.token);
    localStorage.setItem("userEmail", data.email);
    localStorage.setItem("userName", data.name);
    localStorage.setItem("userPlan", data.plan);
    return data;
  },

  logout() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userName");
    localStorage.removeItem("userPlan");
    window.location.href = "/";
  },

  isAuthenticated() {
    return !!localStorage.getItem("authToken");
  },

  getToken() {
    return localStorage.getItem("authToken");
  },

  getUser() {
    return {
      email: localStorage.getItem("userEmail"),
      name: localStorage.getItem("userName"),
      plan: localStorage.getItem("userPlan"),
    };
  },
};
